export const PaymentFormStatus = Object.freeze({
  None: 0,
  Registration: 1,
  WithoutRegistration: 2,
});